/**
 * Converts Contentful's "Video" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import ReactPlayer from 'react-player/lazy'
import playIcon from 'static/images/icons/play.svg'
import styles from './ContentfulVideo.module.scss'

const ContentfulVideo = ({
  className, src, thumbnail,
}) => (
  <div className={cx(styles.playerWrapper)}>
    <ReactPlayer
      className={cx(className, styles.reactPlayer)}
      playIcon={<img src={playIcon} alt="play-icon" />}
      url={src?.file?.url}
      light={thumbnail?.file?.url || false}
      width="100%"
      height="100%"
      controls
      playing />
  </div>
)

ContentfulVideo.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  src: PropTypes.object,
  thumbnail: PropTypes.object,
}

export default ContentfulVideo
